const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setKaratayRuhsatli(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setKaratayRuhsatli({ commit }, data) {
      commit('setKaratayRuhsatli', data)
    },
  },
  getters: {},
}

export default getModule
